import { saveAs } from 'file-saver';

export const saveFile = async (apiResponse, promptSave  = true) => {
    if (apiResponse.ok) {
        var disposition = apiResponse.headers.get('Content-Disposition');
        var defaultFileName = '';
        if (disposition) {
            var match = disposition.match(/.*filename="?([^;"]+)"?.*/);
            if (match[1])
                defaultFileName = match[1];
        }
        defaultFileName = defaultFileName.replace(/[<>:"/\\|?*]+/g, '_');

        const blob = await apiResponse.blob();

        if (promptSave) {
            saveAs(blob, defaultFileName);
        } else {
            return blob;
        }
    } else {
        const json = await apiResponse.json()
        if (json && json.message) {
            throw new Error(json.message);
        } else {
            throw new Error(`${apiResponse.status} ${apiResponse.statusText}`);
        }
    }
}